import { render, staticRenderFns } from "./IncidentDialog.vue?vue&type=template&id=4364f752&scoped=true&"
import script from "./IncidentDialog.vue?vue&type=script&lang=js&"
export * from "./IncidentDialog.vue?vue&type=script&lang=js&"
import style0 from "./IncidentDialog.vue?vue&type=style&index=0&id=4364f752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364f752",
  null
  
)

export default component.exports